var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7364 6.89649L12.7774 6.17579L10.5606 1.68165C10.5001 1.5586 10.4005 1.45899 10.2774 1.39844C9.96882 1.2461 9.59382 1.37305 9.43952 1.68165L7.22272 6.17579L2.26374 6.89649C2.12702 6.91602 2.00202 6.98048 1.90632 7.07813C1.79062 7.19705 1.72686 7.35704 1.72906 7.52294C1.73126 7.68884 1.79923 7.84709 1.91804 7.9629L5.50593 11.4609L4.65827 16.4004C4.63839 16.5153 4.65111 16.6335 4.69497 16.7415C4.73884 16.8496 4.8121 16.9432 4.90645 17.0117C5.0008 17.0802 5.11246 17.1209 5.22878 17.1292C5.34509 17.1375 5.4614 17.113 5.56452 17.0586L10.0001 14.7266L14.4356 17.0586C14.5567 17.1231 14.6973 17.1445 14.8321 17.1211C15.1719 17.0625 15.4005 16.7402 15.3419 16.4004L14.4942 11.4609L18.0821 7.9629C18.1798 7.8672 18.2442 7.74219 18.2637 7.60548C18.3165 7.26368 18.0782 6.94727 17.7364 6.89649Z",
    fill: "#0E51D4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/star-icon.a8dc715fa4c6299c462f33f2a167e894.svg";
export { ForwardRef as ReactComponent };